import { http } from './config/config-receituario'

const jsonHeaders = (token) => ({
  Authorization: token,
  'Content-Type': 'application/json',
})

const cleanParams = (params = {}) =>
  Object.keys(params).reduce((query, key) => {
    const value = params[key]
    if (value !== undefined && value !== null && value !== '' && value !== 'todos') {
      query[key] = value
    }
    return query
  }, {})

const request = (token, config) =>
  http({
    ...config,
    params: cleanParams(config.params),
    headers: {
      ...jsonHeaders(token),
      ...(config.headers || {}),
    },
  }).then((response) => {
    if (response.data && response.data.sucesso === false) {
      const error = new Error(
        response.data.aviso && response.data.aviso.mensagem
          ? response.data.aviso.mensagem
          : response.data.mensagem || 'Nao foi possivel concluir a operacao.'
      )
      error.response = response
      error.businessWarning = true
      throw error
    }

    return response
  })

const getIntegrationClientsSummary = (token) =>
  request(token, {
    method: 'get',
    url: 'integracoes/clientes/resumo',
  })

const listIntegrationClients = (token, params = {}) =>
  request(token, {
    method: 'get',
    url: 'integracoes/clientes',
    params,
  })

const getIntegrationClient = (token, clienteId) =>
  request(token, {
    method: 'get',
    url: `integracoes/clientes/${clienteId}`,
  })

const listIntegrationClientProducers = (token, clienteId, params = {}) =>
  request(token, {
    method: 'get',
    url: `integracoes/clientes/${clienteId}/produtores`,
    params,
  })

const getIntegrationClientProducer = (token, clienteId, produtorId) =>
  request(token, {
    method: 'get',
    url: `integracoes/clientes/${clienteId}/produtores/${produtorId}`,
  })

const listIntegrationClientTechnicians = (token, clienteId) =>
  request(token, {
    method: 'get',
    url: `integracoes/clientes/${clienteId}/responsaveis-tecnicos`,
  })

const getIntegrationClientTechnician = (token, clienteId, responsavelId) =>
  request(token, {
    method: 'get',
    url: `integracoes/clientes/${clienteId}/responsaveis-tecnicos/${responsavelId}`,
  })

const listIntegrationClientPrescriptions = (token, clienteId, params = {}) =>
  request(token, {
    method: 'get',
    url: `integracoes/clientes/${clienteId}/receitas`,
    params,
  })

const getIntegrationClientSettings = (token, clienteId) =>
  request(token, {
    method: 'get',
    url: `integracoes/clientes/${clienteId}/configuracoes`,
  })

const updateIntegrationClientSettings = (token, clienteId, payload) =>
  request(token, {
    method: 'put',
    url: `integracoes/clientes/${clienteId}/configuracoes`,
    data: payload,
  })

const uploadIntegrationClientLogo = (token, clienteId, logo) => {
  const formData = new FormData()
  formData.append('logo', logo)

  return request(token, {
    method: 'post',
    url: `integracoes/clientes/${clienteId}/logo`,
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}

export default {
  getIntegrationClientsSummary,
  listIntegrationClients,
  getIntegrationClient,
  listIntegrationClientProducers,
  getIntegrationClientProducer,
  listIntegrationClientTechnicians,
  getIntegrationClientTechnician,
  listIntegrationClientPrescriptions,
  getIntegrationClientSettings,
  updateIntegrationClientSettings,
  uploadIntegrationClientLogo,
}
